// extracted by mini-css-extract-plugin
export default {"navi-container":"uoaIz_navi-container","navi-back-icon-wrap":"NColF_navi-back-icon-wrap","navi-back-icon":"zpwpj_navi-back-icon","navi-title-text":"H5q21_navi-title-text"};